import {EnrollPersonalInfo} from './enroll-personal-info';
import {EnrollDocuments} from './enroll-documents';
import {EnrollContacts} from './enroll-contacts';
import {EnrollEntranceInfo} from './enroll-entrance-info';
import {EnrollEduInfo} from './enroll-edu-info';
import {EnrollPersonalAchievements} from './enroll-personal-achievements';
import {EnrollContractPaymentsInfo} from './enroll-contract-payments-info';
import {EnrollPrivileges} from './enroll-privileges';
import {EnrollMilitaryRegistration} from './enroll-military-registration';
import {MultiLang} from '../../../admin/models/multiLang';
import {EnrollQuota} from './enroll-quota';
import {EnrollEgovFile} from './enroll-egov-file';

export class EnrollCabinet {
  enrollId: number;
  collegeId: number;
  userCollegeId: number;
  centerCollege: MultiLang;
  personal_info: EnrollPersonalInfo = new EnrollPersonalInfo();
  documents: EnrollDocuments = new EnrollDocuments();
  contacts: EnrollContacts = new EnrollContacts();
  entrance_info: EnrollEntranceInfo = new EnrollEntranceInfo();
  edu_info: EnrollEduInfo = new EnrollEduInfo();
  personal_achievements: EnrollPersonalAchievements = new EnrollPersonalAchievements();
  contract_payments_info: EnrollContractPaymentsInfo = new EnrollContractPaymentsInfo();
  privileges: EnrollPrivileges = new EnrollPrivileges();
  quota: EnrollQuota = new EnrollQuota();
  military_registration_data: EnrollMilitaryRegistration = new EnrollMilitaryRegistration();
  egovFiles: EnrollEgovFile[] = [];
  signedXml: string;
  simpleSave: boolean;
  fromEgov: boolean;
  pepRequestId: number;
  isCurrentUserApplicant = false;
  applicationSubmissionCompletedMessage;
  preliminaryGrant: number;
  finalGrant: number;
  applicantStatus: number;
  rejectedReason: string;
  rejectedPersonCollege: string;
  alternativeColleges = [];
  grantRejectionStatus: string;
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/model/enroll-cabinet.ts